import { Box } from '@mui/material';
import { useState } from 'react';
import { TopItemListProps } from 'react-virtuoso';
import { OrderProductsStickyParentGroupSlotContext } from '../../contexts/OrderProductsStickyParentGroupSlot.context';

const TOP_ITEM_LIST_Z_INDEX = 2;

const OrderProductsTopItemList = ({ children, style }: TopItemListProps) => {
  const [parentGroupSlot, setParentGroupSlot] = useState<HTMLDivElement | null>(null);

  return (
    <Box
      sx={{ backgroundColor: 'background.paper' }}
      style={{ ...style, zIndex: TOP_ITEM_LIST_Z_INDEX }}
    >
      <Box ref={setParentGroupSlot} />
      <OrderProductsStickyParentGroupSlotContext.Provider value={parentGroupSlot}>
        {children}
      </OrderProductsStickyParentGroupSlotContext.Provider>
    </Box>
  );
};

export default OrderProductsTopItemList;
